import axios from "axios";
import { getApiConfig } from "../config.js";

const MASTER_ADMIN_INSTITUTIONS_PATH = "/master-admin/institutions";

export const APIGetMasterAdminInstitutions = async (
  setLoading,
  firebaseToken
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const result = await axios.get(
      `${apiConfig.baseURL}${MASTER_ADMIN_INSTITUTIONS_PATH}`,
      {
        headers: {
          Authorization: `Bearer ${firebaseToken}`,
          ...apiConfig.headers,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error fetching master admin institutions:", error);
    return error;
  }
};

export const APICreateInstitution = async (
  institutionData,
  setLoading,
  firebaseToken
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const result = await axios.post(
      `${apiConfig.baseURL}${MASTER_ADMIN_INSTITUTIONS_PATH}`,
      institutionData,
      {
        headers: {
          Authorization: `Bearer ${firebaseToken}`,
          ...apiConfig.headers,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error creating institution:", error);
    return error;
  }
};

export const APIPatchMasterAdminInstitution = async (
  institutionId,
  body,
  setLoading,
  firebaseToken
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const result = await axios.patch(
      `${apiConfig.baseURL}${MASTER_ADMIN_INSTITUTIONS_PATH}/${encodeURIComponent(institutionId)}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${firebaseToken}`,
          ...apiConfig.headers,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error updating institution:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIDeleteMasterAdminInstitution = async (
  institutionId,
  documentObjectId,
  setLoading,
  firebaseToken
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const result = await axios.delete(
      `${apiConfig.baseURL}${MASTER_ADMIN_INSTITUTIONS_PATH}/${encodeURIComponent(institutionId)}`,
      {
        headers: {
          Authorization: `Bearer ${firebaseToken}`,
          ...apiConfig.headers,
        },
        data: { _id: String(documentObjectId) },
      }
    );
    return result;
  } catch (error) {
    console.error("Error deleting institution:", error);
    return error;
  } finally {
    setLoading(false);
  }
};
